import React from "react"
import Container from "../Container"
import { Props } from "./props"

const Widget: React.FC<Props> = (props) => (
  <Container contentType="widget" {...props} />
)
export default Widget
